<template>

	<div class="file-drop" :class="{box: styleType == 'box', link: styleType != 'box'}">

		<div class="d-flex flex-column justify-content-center align-items-center">
			<div v-if="fileUpload.msg" class="file-label" :class="fileUpload.class">{{ fileUpload.msg }}</div>
			<i v-if="icon && !uploading" :class="icon" class="fa fa-2x upload-icon"></i>

			<div v-else-if="icons && !uploading">
				<i v-for="icon in icons" :class="icon" class="fa fa-2x mr-1 upload-icon"></i>
			</div>
		</div>

		<div class="prog-bar" :class="{'prog-transition': transitionClass}" :style="{width: fileUpload.progress+'%'}"></div>

		<fileupload
			style="cursor: pointer"
			class="input-file"
			:target="fileUpload.target" 
			action="POST"
			:accept="localFilesAccepted"
			:multiple="multiple"
			v-on:start="startUpload"
			v-on:finish="finishUpload"
			v-on:progress="uploadProgress">
		</fileupload>

	</div>

</template>

<script type="text/javascript">
	import FileUpload from './FileUpload'

	export default {
		name: "UploadField",
		props: ["value",
			"uploadMsg",
			"target",
			"styleType", //'box' or nothing
			"icon", //single icon
			"icons", //array of icons
			"accept", //accepts comma separated list of file extensions (including period), or 'images', 'documents', or 'documents/images'. If not set, defaults to jpg, jpeg, and png
			"multiple",
			"hideUploadingMsg"
		],
		components: {
			'fileupload': FileUpload
		},
		data() {
			return {
				activeValue: this.value,
				uploading: false,
				fileUpload: {
					msg: this.uploadMsg,
					target: window.apiBase+this.target+"?token="+this.$store.sessionToken,
					responseFilename: "",
					fileFormat: "",
					progress: 0,
					class: "progress-text",
					
				},
				transitionClass: true
			}
		},
		computed: {
			localFilesAccepted() {
				if (!this.accept) 
					return "image/*" //default to images
				
				else if (this.accept == "images") 
					return "image/*"
				
				else if (this.accept == "documents") 
					return ".doc, .docx, .xls, .xlsm, .pdf, .rtf, .txt, .ppt"
				
				else if (this.accept == "documents/images") 
					return ".doc, .docx, .xls, .xlsm, .pdf, .rtf, .txt, .ppt, image/*"
				
				else
					return this.accept
			},
			captureAttribute() {
				if (this.localFilesAccepted.search(/jpg|jpeg|png|gif|image/) >= 0)
					return "environment"

				return false
			}
		},
		methods: {
			resetFileUpload() {
				this.setSessionToken() //make sure session token is fresh

				let vm = this
				vm.fileUpload = {
					msg: vm.uploadMsg ? vm.uploadMsg : "",
					progress: 0,
					class: "progress-text",
					width: 0,
					target: window.apiBase+vm.target+"?token="+vm.$store.sessionToken
				}
			},
			startUpload(e) {
				if (!this.hideUploadingMsg) 
					this.fileUpload.msg = "Uploading..."
				else
					this.fileUpload.msg = ""

				this.transitionClass = true
				this.uploading = true
				this.$emit("uploadStarted")
			},
			finishUpload(e){

				let response = JSON.parse(e.target.response)

				if (response.success) {
					this.fileUpload.msg = "Upload Complete"
					this.fileUpload.responseFilename = response.filename
					this.fileUpload.submitVisible = true

					this.$emit("uploaded",response)

					let vm = this
					this.transitionClass = false
					this.uploading = false

					setTimeout(function(){
						vm.resetFileUpload()
					},1000)
				}
				else {
					this.fileUpload.msg = response.errors
					this.fileUpload.class = "text-danger"
				}		
			},
			uploadProgress(e) {
				if (!this.hideUploadingMsg) {
					// file upload progress
					// returns false if progress is not computable
					this.fileUpload.msg = "Uploading... " + e + "%";
				}
				else 
					this.fileUpload.msg = ""

				this.fileUpload.progress = e-10
			
			},
		},
		created() {
			this.resetFileUpload()
		}
	}
</script>

<style type="text/css" scoped>

	.file-drop {
		position: relative;
		cursor: pointer;
		overflow: hidden;
	}

	.file-drop.link {
		min-height: 30px; /* minimum height */
	}

	.file-drop.link:hover .file-label {
		text-decoration: underline;
	}

	.file-drop.box {
		outline: 1px solid grey; /* the dash box */
		outline-offset: -5px;
		/*background: #cdf3e1;*/
		color: dimgray;
		padding: 10px 10px;
		min-height: 50px; /* minimum height */
		position: relative;
		cursor: pointer;
		margin-bottom: 10px;
		/*
		background-image: 
			linear-gradient(45deg, #e0e0e0 25%, transparent 25%), 
			linear-gradient(-45deg, #e0e0e0 25%, transparent 25%), 
			linear-gradient(45deg, transparent 75%, #e0e0e0 75%), 
			linear-gradient(-45deg, transparent 75%, #e0e0e0 75%);
		*/
		background-color: #ecedf1;
		background-size: 10px 10px;
		background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
		text-align: center;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.file-drop i {
		margin-top: 5px;
	}

	.file-drop .file-label {
		
		left: 0;
		width: 100%;
		text-align: center;
		z-index: 2;
	}

	.file-drop.box .file-label {
		top: 18px;
	}

	.file-drop.link .file-label {
		top: 7px;
	}

	.input-file {
		opacity: 0;
		height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
	}

	.prog-bar {
		position: absolute;
		top: 5px;
		left: 5px;
		background-color: var(--brand-primary-color);
		width: 0%;
		z-index: 1;
		height: calc(100% - 10px);
	}

	.prog-transition {
		transition: 1s width;
	}

	.progress-text {
		color: #007bff;
	}

	.box .progress-text {
		color:#6d6135 
	}
</style>